// @ts-check
// Registry of built-in default skins. Structured as a flat list so more skins (and later,
// custom/cloud-uploaded skins) can be added without touching the picker UI logic.
export const builtinSkins = [
  { id: 'steve', name: 'Steve', url: '/skins/steve.png' },
  { id: 'alex', name: 'Alex', url: '/skins/alex.png' },
  { id: 'ember', name: 'Ember', url: '/skins/ember.png' },
  { id: 'frost', name: 'Frost', url: '/skins/frost.png' },
  { id: 'moss', name: 'Moss', url: '/skins/moss.png' },
];

export const getSkinUrlById = (skinId) => {
  const found = builtinSkins.find((s) => s.id === skinId);
  return found ? found.url : builtinSkins[0].url;
};
